import {II18nMap as CommonII18nMap} from "@buildwitt/shapeshift-common/v2/i18n";

const enAdditional = {

	"page_progress_title": "My Progress",
	"page_progress_finished_courses": "Finished Courses",
	"page_progress_finished_courses_subtitle": "See what courses you’ve completed so far",
	"page_progress_active_courses": "Active Courses",
	"page_progress_active_courses_subtitle": "Jump back into courses you participate in",
	"page_progress_recent_activity": "Recent Activity",
	"page_progress_recent_activity_subtitle": "See what you’ve completed so far",
	"page_progress_no_courses": "No courses completed",
	"page_progress_resume_button": "Resume",

	"page_settings_title": "Training Preferences",
	"page_settings_language": "Preferred language",
	"page_settings_english": "English",
	"page_settings_spanish": "Spanish",
	"page_settings_manage_account": "Manage account details",
	"page_settings_save_button": "Save",
	"page_settings_cancel_button": "Discard",

	"page_feed_title": "My Feed",

	"page_notes_title": "Notes library",
	"page_notes_all": "All",

	"page_streak": "Complete all tasks due today to increase your daily streak",

	"search_courses": "Search courses",

	"search_placeholder": "Course Title, Lesson Title, Author, Lesson Description",

	"nav_feed": "My Feed",
	"nav_library": "Course Library",
	"nav_progress": "My Progress",
	"nav_notes": "My Notes",
	"nav_manager": "Content Manager",

	"nav_mobile_feed": "Feed",
	"nav_mobile_library": "Library",
	"nav_mobile_progress": "Progress",
	"nav_mobile_notes": "Notes",

	"menu_profile_settings": "Training Preferences",
	"menu_profile_account": "My Account",
	"menu_profile_support": "Support",
	"menu_profile_logout": "Log Out",

	"notifications_settings_updated": "Your details have been updated",
	"notifications_wrong_title": "Something went wrong",
	"notifications_wrong_body": "Please try again",
	"notifications_reschedule_success": "Lessons rescheduled successfully.",
	"notifications_reschedule_error": "Unable to reschedule lessons. Please try again.",
	"menu_profile_language_settings": "Language Preferences",
	"menu_profile_profile": "Profile",
	"menu_profile_report_issue": "Report issue",
	"menu_profile_suggest_feature": "Suggest a feature",
	"team_progress_widget_completedCourses": "Completed Courses",
	"team_progress_widget_completedLessons": "Completed Lessons",
	"team_progress_widget_timeInTraining": "Total Watch Time",
	"team_progress_widget_activeUsers": "Users with lesson completions",
	"team_progress_widget_inactiveUsers": "Users without lesson completions",
	"team_progress_widget_usersWithOverdueLessons": "Users With Overdue Lessons",
	"team_progress_under_construction": "Under Construction",
	"team_progress_filter_last_week": "This Week",
	"team_progress_filter_last_month": "This Month",
	"team_progress_filter_last_year": "This Year",
	"team_progress_filter_custom_date_range": "Custom Date Range",
	"team_progress_filter_archived_users": "Show inactive",
	"team_progress_calendar_add": "Add",
	"team_progress_calendar_cancel": "Cancel",
	"team_progress_title": "Team Progress",
	"team_progress_subtitle": "Monitor learning engagement and employee progress",

	// User enrollment types
	"user_enrollment_type_learner": "Self Assigned",
	"user_enrollment_type_strapi-admin": "Admin Assigned",
	"user_enrollment_type_auto-assign-schedule": "Auto Assigned",
	"user_enrollment_type_prioritize-schedule": "Prioritize Assigned",
	"user_enrollment_type_due-date-schedule": "Due Date Assigned",

	// Course categories
	"course_category_Job Training": "Job Training",
	"course_category_Personal Development": "Personal Development",
	"course_category_Professional Development": "Professional Development",
	"course_category_Safety": "Safety",
	"course_category_others": "Others",

	"completed_lessons_column_firstname": "First Name",
	"completed_lessons_column_lastname": "Last Name",
	"completed_lessons_column_lesson": "Lesson",
	"completed_lessons_column_duration": "Duration",
	"completed_lessons_column_supervisor": "Supervisor",
	"completed_lessons_column_division": "Division",
	"completed_lessons_column_job_category": "Job Category",
	"completed_lessons_column_completed_on": "Completed on",
	"completed_lessons_column_enrollment_type": "Enrollment Type",
	"completed_lessons_column_course": "Course",
	"completed_lessons_column_email": "Email",
	"completed_lessons_column_phone": "Phone",
	"completed_lessons_column_job_title": "Job Title",
	"completed_lessons_column_status": "Status",
	"completed_lessons_column_streak": "Streak",
	"completed_lessons_viewing_stats_past_week": "VIEWING STATS FROM THE PAST WEEK",
	"completed_lessons_viewing_stats_past_month": "VIEWING STATS FROM THE PAST MONTH",
	"completed_lessons_viewing_stats_past_year": "VIEWING STATS FROM THE PAST YEAR",
	"completed_lessons_viewing_stats_custom_range": "VIEWING STATS FROM ",
	"completed_lessons_viewing_stats_all_time": "VIEWING STATS FROM ALL TIME",
	"data_grid_export_tooltip": "Coming Soon",
	"common_content_type": "Content Type",
	"common_last_active": "Last Active",
	"common_lessons": "Lessons",
	"time_in_training": "Total Watch Time",
	"completed_lessons": "Completed Lessons",
	"no_courses_found": "No Courses Found",
	"common_export": "Export",
	"team_progress_one_report_a_time_msg": "You can only download one report at a time.",
	"team_progress_generating_your_report_msg": "Generating your report… Don't close or refresh this window.",
	"team_progress_download_report_has_started": "Your download has started.",
	"team_progress_download_export_failed": "Export failed. Please try again.",
	"common_overdue_lessons": "Overdue Lessons",
	"common_reschedule_overdue": "Reschedule Overdue",
	"common_reschedule_overdue_tooltip_msg": "Reschedule overdue lessons for selected users",
	"streak_day": "day streak",
	"streak_days": "day streak",
	"streak_day_message": "Complete one lesson to keep your streak.",
	"streak_lesson_completed": "Today's lesson completed! Come back tomorrow to continue your streak.",
	"streak_day_off": "You’ve got the day off. Your progress is safe and steady.",
	"common_confirm": "Confirm",
	"bulk_reschedule_modal_title": "Reschedule Overdue Lessons",
	"bulk_reschedule_modal_body_copy": "This will reschedule lessons for all selected users who have overdue assignments.",
	"bulk_reschedule_progress_msg": "Rescheduling overdue lessons… Don't close or refresh this window.",
	"bulk_reschedule_error_msg": "Unable to reschedule lessons. Please try again.",
	"bulk_reschedule_success_msg": "Successfully rescheduled overdue lessons for selected users",

	"bulk_enrollment_modal_title_other": "Enroll Users in Course",
	"bulk_enrollment_modal_title_one": "Enroll User in Course",
	"bulk_enrollment_modal_body_copy_other": "This will enroll the selected users in the course. Choose how you want to schedule this course in their training feed.",
	"bulk_enrollment_modal_body_copy_one": "This will enroll the selected user in the course. Choose how you want to schedule this course in their training feed.",
	"bulk_enrollment_prioritize_option": "Prioritize in Training Feed",
	"bulk_enrollment_due_date_option": "Due Date",
	"bulk_enrollment_due_date_label": "Due Date",
	"bulk_enrollment_progress_msg": "Enrolling users… Don't close or refresh this window.",
	"bulk_enrollment_error_msg": "Unable to enroll users. Please try again.",
	"notifications_enrollment_success": "Users enrolled successfully.",
	"notifications_enrollment_error": "Unable to enroll users. Please try again.",
	"streak_drawer_text_content_tier2.1": "You started a streak.",
	"streak_drawer_text_content_tier2.2": "Let discipline compound.",
	"streak_drawer_text_content_tier3.1": "{{x}} day streak.",
	"streak_drawer_text_content_tier3.2": "Habits are the quiet",
	"streak_drawer_text_content_tier3.3": "engine of success.",
	"streak_drawer_text_content_tier4.1": "{{x}} day streak.",
	"streak_drawer_text_content_tier4.2": "No shortcuts, no excuses",
	"streak_drawer_text_content_tier4.3": "— just progress.",
	"common_congrats": "Congrats",
	"common_continue": "Continue",
	"completion_celebration_congratulations": "Congratulations!",
	"completion_celebration_you_completed": "You completed",
	"completion_celebration_you_did_it": "You did it!",
	"settings_import_libraries": "Import Libraries",
	"training_feed_watch_lesson": "Watch lesson",
	"training_feed_tap_to_load": "Tap to load",
	"training_feed_nothing_scheduled": "Nothing scheduled",
	"training_feed_overdue": "OVERDUE",
	"training_feed_upcoming": "UPCOMING",
	"training_feed_due_today": "DUE TODAY",
	"month_jan": "Jan",
	"month_feb": "Feb",
	"month_mar": "Mar",
	"month_apr": "Apr",
	"month_may": "May",
	"month_jun": "Jun",
	"month_jul": "Jul",
	"month_aug": "Aug",
	"month_sep": "Sep",
	"month_oct": "Oct",
	"month_nov": "Nov",
	"month_dec": "Dec",
	"mark_as_completed": "Mark as completed",
	"module_tab_overview": "OVERVIEW",
	"module_tab_comments": "COMMENTS",
	"module_tab_notes": "NOTES",
	"please_scroll_to_continue": "Please scroll to continue",
	"view_more": "View more",
	"view_less": "View less",
	"quiz.submit_answers": "Submit answers",
	"quiz.next_question": "Next question",
	"quiz.previous_question": "Previous question",
	"quiz.back": "Back",
	"quiz.question_text": "Question",
	"quiz.of_text": "of",
	"quiz.one_answer": "1 answer",
	"quiz.multiple_answers": "answers",
	"quiz.drag_to_order": "Drag rows to correct order",
	"notes.most_recent": "Most recent",
	"notes.oldest_first": "Oldest first",
	"notes.input_placeholder": "Write your private note",
	"comments.load_more": "Load more",
	"comments.input_placeholder": "Leave a comment",
	"comments.reply_to_user": "Reply to {userName}",
	"comments.replies": "replies",
	"comments.today": "Today",
	"comments.yesterday": "Yesterday",
	"comments.days_ago": "{count} days ago",
	"notifications_title": "Notifications",
	"notifications_mark_all_read": "Mark all as read",
	"notifications_clear_all": "Clear all",
	"notifications_all_up_to_date": "You are all up to date!",
	"notifications_marked_all_read": "Marked all notifications as read",
	"notifications_close_drawer": "Close notifications drawer",
	"view_all": "View all",
	"confirm_bulk_enrollment_title": "Confrm Bulk Enrollment",
	"course_library_enroll_button": "ENROLL",
	"course_library_overview_tab": "Overview",
	"course_library_lessons_tab": "Lessons",
	"course_library_breadcrumb_courses": "Courses",
	"course_overview_title": "Course Overview",
	"course_overview_number_of_lessons": "Number of Lessons:",
	"course_lessons_table_title": "Title",
	"course_lessons_table_subtitle": "Subtitle",
	"course_lessons_table_duration": "Duration",
	"course_lessons_title": "Lessons",
	"course_lessons_table_total_rows": "Total Rows:",
	"common_unsaved_changes_title": "Unsaved changes will be lost",
	"common_unsaved_changes_message": "You'll lose any unsaved work if you exit now. Do you want to proceed?",
	"common_exit": "Exit",
	"common_keep_editing": "Keep Editing",
	"bulk_playlist_enrollment_modal_title": "Enroll Users in Playlist",
	"bulk_playlist_enrollment_modal_content_1": "Enrolling a user onto a playlist will add training to the top of your employee's training feed.",
	"bulk_playlist_enrollment_modal_content_2": "Important: Please note that prioritizing courses may push other items down the list and impact other courses due dates.",
	"bulk_playlist_enrollment_modal_content_3": "{{users}} users selected",
	"bulk_enrollment_confirm_title": "Confirm Bulk Enrollment",
	"admin_users_list_subtitle": "View and manage learner progress",
	"playlist_award_certification_label": "Award a certification when learners complete this playlist",
	"playlist_select_certificate_label": "Select Certificate",
	"common_unsaved_data_title": "Unsaved data will be lost",
	"playlist_save_success": "Information saved successfully",
	"playlist_save_error": "Unable to save information. Please try again.",
	"common_name": "Name",
	"common_description": "Description",
	"common_Required": "Required field",
	"certification_manage": "Manage Certification",
	"certification_employees_awarded": "Employees Awarded",
	"certification_recently_added": "Recently Added",
	"certification_add": "Add Certification",
	"certification_name": "Certification Name",
	"certification_code": "Certification Code",
	"certification_granting_organization_name": "Granting Organization Name",
	"certification_expiration": "Certification Expiration",
	"certification_enter_number": "Enter Number",
	"certification_select_expirationUnit": "Select Expiration Unit",
	"certification_logo": "Certification Logo",
	"invalid_file_type": "Invalid file format. Try again",
	"file_too_large": "Please choose a file smaller than {{number}} MB.",
	"certification_empty_logo": "Upload Certification Logo",
	"course_draft_not_enrollment_description": "Please publish the course to enable user enrollments.",
	"prioritized_enrollment_tooltip_copy": "Prioritized enrollment will start on users next available day",
	"common_paused": "Paused",
	"streak_unpause": "Unpause Streak",
	"streak_pause": "Pause Streak",
	"streak_paused": "Streak Paused",
	"streak_paused_message": "Your streak is paused, but your due dates will continue as scheduled.",
	"streak_unpaused_message": "Streak pause removed.",
	"streak_unpause_question": "You completed a lesson, but your streak is paused. Do you want to unpause it?",
	"page_home": "Home",
	// Scheduled Reports - Overview Card Tooltips
	"scheduled_reports_tooltip_total_watch_time": "Total time spent watching lessons during this reporting period, calculated by summing the video length of all completed lessons.",
	"scheduled_reports_tooltip_users_with_completed_lessons": "Percentage of users who completed at least one lesson during this reporting period.",
	"scheduled_reports_tooltip_average_watch_time": "Average time spent watching lessons per user, calculated by dividing total watch time by the total number of users.",
	"scheduled_reports_tooltip_completed_lessons": "Total number of lessons completed by all users during this reporting period.",
	"scheduled_reports_tooltip_completed_courses": "Total number of courses completed by all users during this reporting period.",
	"scheduled_reports_tooltip_average_streak": "Average daily streak across all users. As of the time this report was generated.",
	"scheduled_reports_tooltip_overdue_lessons": "Total number of lessons that are past their due date and not yet completed.",
	"scheduled_reports_tooltip_utilization": "Percentage of active subscribers who completed at least one lesson during this reporting period."
}

export const enCommonOverride: Partial<CommonII18nMap> = {
	"common_notes_delete": "Delete",
	"common_notes_edit": "Edit",
	"common_notes_cancel": "Cancel"
};

export const en = {...enAdditional, ...enCommonOverride}

export type II18nMap = {
	[K in keyof (typeof enAdditional & typeof enCommonOverride)]: string;
};
